import { BsDownload } from "react-icons/bs";
export const DownloadIcon = ({ ...rest }) => {
  return <BsDownload {...rest} />;
};
